module.exports = __webpack_public_path__ + "static/img/SUB_02_01.58227a3.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/sub/SUB_02_01.png
// module id = FOF7
// module chunks = 1